import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../../../../chat-common/src/lib/services/auth.service';

/**
 * Report pages only need a session. Links carrying `#token=<accessCode>` are logged in
 * at startup by accessCodeFragmentInitializer, before this guard runs.
 */
export const reportAuthGuard: CanActivateFn = (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.isLoggedIn ? true : router.createUrlTree(['/login']);
};
